<!-- Header personalizado -->
<mat-drawer-container class="drawer-container" autosize>
   
    <mat-drawer #drawer mode="over" position="end" class="half-drawer">
        <app-sidenav-library-objects [project_id]="project_id" (closeSidenav)="onCloseSidenav()"></app-sidenav-library-objects>
    </mat-drawer>
    <mat-drawer-content>

<div class="project-header" >
    <div class="left">
      <app-menu-toggle></app-menu-toggle>
      <button mat-icon-button (click)="goback()" aria-label="Volver">
      <mat-icon>arrow_back</mat-icon>
    </button>
      <strong>Proyecto:</strong> {{ projectDetails?.name }}
    </div>
    <div class="right" *ngIf="projectDetails">
        #{{ projectDetails.id }} created by {{ projectDetails.owner.username}}
        <br>
        {{ formatDate(projectDetails.created_date) }}
    </div>
</div>
<ng-container  >
<div class="project-container">
     
     <div class="table-box">
    <div class="title-container">
    <span class="title">Etiquetas</span>
    <div class="button-group">
      <button mat-flat-button (click)="drawer.open()">Añadir</button>
      <button mat-flat-button  color="warn" [disabled]="!selectedItems.length" (click)="onDeleteLabels(selectedItems)">Eliminar</button>
    </div>
  </div>

    <app-table-custom-filter class="table" [data]="data" [columns]="columns"
        [rows]="rows" [first]="first" [totalRecords]="totalRecords" (rowSelect)="onRowSelect($event)" [selection]="selectedItems"
        (selectionChange)="onSelectionChange($event)"  [sortOrder]="-1" [showFilters]="true"
        [showGlobalSearch]="true" [globalFilterFields]="globalFilterFields" [optional]="false" (lazyLoad)="loadLabelsLazy($event)" [enableTotalSelection]="true" >
    </app-table-custom-filter>

    </div>
<div >
    <router-outlet></router-outlet>
</div>

</div>
</ng-container>

<!-- <ngx-ui-loader
  [fgsType]="'three-strings'"
  [fgsSize]="40"
  [fgsColor]="'#7b08ce'"
  [hasProgressBar]="true"
  overlayColor="rgba(255,255,255,1)"
  text="Cargando..."
  textColor="#7b08ce"
  textPosition="center-center"
></ngx-ui-loader> -->

</mat-drawer-content>
</mat-drawer-container>
